export class UpdateWorkTypePricingError extends Error {

}
